import { createEventHandler } from '../../utils/pollard'

export default (url: string) =>
  createEventHandler(() => {
    window.location.assign(url)
  })
